/* global process */
import axios from 'axios';
import { AuthService} from '@/services';

let frontend = axios.create({
  baseURL: `/portal`,
});

frontend.defaults.headers['x-api-key'] = process.env.VUE_APP_TOKEN_API_KEY;
frontend.defaults.headers['x-client-version'] = process.env.VUE_APP_CLIENT_VERSION;

frontend.interceptors.response.use((response) => {
  return response;
}, (error) => {
  if(error.response.status === 401) {
    AuthService.signOutUser();
  }

  return Promise.reject(error);
});

export default frontend;
